import { render, staticRenderFns } from "./addstock_excel.vue?vue&type=template&id=3b634248&scoped=true"
import script from "./addstock_excel.vue?vue&type=script&lang=js"
export * from "./addstock_excel.vue?vue&type=script&lang=js"
import style0 from "./addstock_excel.vue?vue&type=style&index=0&id=3b634248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b634248",
  null
  
)

export default component.exports